import { ButtonVariant, CoButton } from "components/CoButton";
import PaperActionButtons from "components/DetailContent/PaperActionButtons";
import ContentWrapper from "components/Layout/ContentWrapper";
import { AbstractLoading } from "components/Loading/AbstractLoading";
import { BadgesLoading } from "components/Loading/BadgesLoading";
import { CitationDetailsLoading } from "components/Loading/CitationDetailsLoading";
import { QuartileLoading } from "components/Loading/QuartileLoading";
import { SnapshotLoading } from "components/Loading/SnapshotLoading";
import useLabels from "hooks/useLabels";

export default function LoadingDetail() {
  const [studySnapshotTitle] = useLabels("study-snapshot.title");

  return (
    <ContentWrapper>
      <div
        data-testid="loadingdetail"
        className="w-full stagger-animation pt-16"
      >
        <div data-testid="result-paper ">
          <div className="bg-border-base h-[18px] animate-pulse w-full  rounded-xl mb-1.5" />
          <div className="bg-border-base h-[18px] animate-pulse w-[45%] rounded-full" />

          <div className="flex flex-row items-center mt-3 gap-x-2 animate-pulse">
            <div className="bg-bg-subtle w-[93px] h-3 rounded-full" />
            <span className="text-fg-muted">&middot;</span>
            <div className="bg-bg-subtle h-3 w-[262px] rounded-full " />
          </div>

          <div className="flex mt-6 justify-between flex-wrap gap-4 animate-pulse">
            <QuartileLoading />
            <CitationDetailsLoading />
          </div>
          <div className="flex mt-6 justify-between flex-wrap gap-4">
            <PaperActionButtons />
            <CoButton
              variant={ButtonVariant.Flat}
              icon="icon-ellipsis"
              disabled
            />
          </div>
        </div>
        <div className="w-full h-px bg-bg-subtle my-[20px]" />

        <div className="w-full mb-6">
          <AbstractLoading />
          <BadgesLoading isEvenIndex={false} />
        </div>
        <div className="w-full">
          <p className="mb-4 base-bold text-fg-base">{studySnapshotTitle}</p>
          <SnapshotLoading />
        </div>
      </div>
    </ContentWrapper>
  );
}
